import { Navigate } from "react-router";
import { page, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  public: [{ path: "sign-in", lazy: page(() => import("./SignInPage")) }],
  // The account lives in Settings now (one settings screen); old links still land there.
  shell: [{ path: "account", element: <Navigate to="/settings" replace /> }],
};
